module.exports = {
    visualization: "Vizualizácia",
    analytics: "Analytika",
    profile: "Profil",
    dashboard: "Nástenka",
    realtime: "V reálnom čase",
    voltage: "Napätie",
    current: "Prúd",
    active_power: "Činný výkon",
    reactive_power: "Jalový výkon",
    apparent_power: "Zdanlivý výkon",
    energy_export: "Energia dodávka",
    energy_import: "Energia odber",
    hourly_active_report: "Hodinový report činnej energie",
    daily_active_report: "Denný report činnej energie",
    monthly_active_report: "Mesačný report činnej energie",
    daily_reactive_report: "Denný report jalovej energie",
    language_change: "Lokalizácia",
    disaggregation: "Disagregácia",
    appliances_imprints: "Odtlačky spotrebičov",
    appliances_energy: "Spotreba spotrebičov",
    appliances_timeline: "Časová os spotrebičov",
    appliances_run_profile: "Spotrebiče na výkonovom profile",
    imprints_map: "Mapa odtlačkov spotrebičov",
    logout: "Odhlásiť sa",
    logout_mini: "O",
    edit_profile: "Upraviť profil",
    edit_profile_mini: "UP",
    monitoring: "Dostupnosť",
    tools: "Nástroje",
    manual_learning: "Manuálne učenie",
    settings: "Nastavenia",
    disconnector_timeline: "Časová os",
    energy_profile: "Energeticky profil",
    power_factor: "Účinník",
    test_profile: "Testovací profil",
    quarter_hour_active_report: "Činná energia za 15 minút",
    testing_process: "Proces testovania",
    tests_results: "Výsledky testov",
    integration: "Integrácia",
    quarter_hour_maximum_active_report: "Maxima za 15 minút",
    reactive_energy: "Reaktívna energia",
    state: "Stav",
    rising_shapes: "Nabehové krivky",
    falling_shapes: "Dobehové krivky",
    firmware_upgrade: "Aktualizácia softvéru",
    control_map: "Ovládacia mapa",
    notifications: "Notifikácie",
    anomaly_models: "Anomálne modely"
  }